export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-5babcea25afb5673452ab5db68df1fc2.svg";